function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "n5fy4wnnka",
  d: "M17.33 23.385c.443 0 .809-.377.82-.823l.238-10.123c.01-.453-.348-.834-.801-.845-.46-.006-.83.345-.84.798l-.238 10.132c-.011.453.347.86.8.86h.02zm-3.867 0h.02c.453 0 .811-.436.8-.89l-.238-10.135c-.01-.453-.382-.823-.84-.813-.453.01-.811.38-.8.833l.238 10.157c.01.447.375.848.82.848zM13.07 8.147h4.688V6.974H13.07v1.173zm12.425.937c0 .518-.42.938-.938.938H6.27c-.518 0-.938-.42-.938-.938s.42-.937.938-.937h5.158v-2.11c0-.454.302-.704.755-.704h6.46c.453 0 .755.25.755.704v2.11h5.158c.518 0 .938.42.938.937zm-2.486 3.139l-.716 13.555c-.026.498-.438.889-.936.889H9.47c-.499 0-.91-.39-.936-.889l-.716-13.555c-.027-.517.37-.959.887-.986.52-.025.959.37.986.887l.669 12.667h10.106l.669-12.667c.027-.517.472-.91.986-.887.517.027.914.469.887.986z",
  fill: "#d93845"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-629.000000, -703.000000) translate(293.000000, 499.000000) translate(32.000000, 164.000000) translate(304.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "l9fgogn0ob",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#n5fy4wnnka"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#D93845",
  xlinkHref: "#n5fy4wnnka"
}))))));

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.e53c6ab0.svg";
export { ForwardRef as ReactComponent };